<template>
  <div class="mt-3">
    <div class="text-h6 mb-3">{{ question }}</div>
    <div class="d-flex ga-3">
      <v-btn class="flex-grow-1" :variant="modelValue !== 'yes' ? 'outlined' : 'flat'" color="primary" @click="yesClicked">Yes</v-btn>
      <v-btn class="flex-grow-1" :variant="modelValue !== 'no' ? 'outlined' : 'flat'" color="primary" @click="noClicked">No</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "YesNo",
  props: {
    question: {
      type: String,
      required: true
    },
    req: {
      type: Boolean,
      default: false
    },
    modelValue: {
    }
  },
  methods: {
    yesClicked() {
      this.$emit('update:modelValue', 'yes')
    },
    noClicked() {
      this.$emit('update:modelValue', 'no')
    },
    skipClicked() {
      this.$emit('update:modelValue', 'skipped')
    }
  }
}
</script>

<style scoped>

</style>
